module.exports = __webpack_public_path__ + "static/media/radio_outline.c68526ff.svg";